import React from "react";
import { SectionFlexColumn } from "../../../components/General";
import { ReactComponent as SuccessIcon } from "../../../assets/icons/success.svg";
import Button from "../../../components/Button";
import useCompleteOnboarding from "../../../hooks/mutations/admin/useCompleteOnboarding";

const Congrats = () => {
  const { mutate: completeOnboarding } = useCompleteOnboarding();
  return (
    <SectionFlexColumn
      style={{
        width: "100%",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SectionFlexColumn
        style={{ width: "45%", alignItems: "center", textAlign: "center" }}
      >
        <SuccessIcon />
        <h2 style={{ marginBottom: 0 }}>That's it for now, congrats!</h2>
        <p>
          We will be in touch with next steps on payroll files and employee
          marketing materials for your review.
        </p>
        <Button
          style={{
            width: "auto",
            paddingRight: 30,
            paddingLeft: 30,
            marginTop: 10,
          }}
          onClick={() => completeOnboarding()}
        >
          Go to Dashboard
        </Button>
      </SectionFlexColumn>
    </SectionFlexColumn>
  );
};

export default Congrats;
